import React, {Component} from 'react';
import ShopItems from 'app/components/shop/lootboxes/shop_items';
import {ShopStore} from 'app/store/ShopStore';
import {Outlet} from 'react-router';
import {inject, observer} from 'mobx-react';
import withRouter from 'app/utils/navigate/customWithRouter';
import EmptyShopResult from 'app/components/shop/lootboxes/EmptyShopResult';
import {isUSD} from 'app/utils/ShopItemPriceFormat';
import ShopItemInterface from 'app/interfaces/shop/ShopItemInterface';
import {isDesktop} from 'app/utils';

interface CasinoLootboxesInterface {
    currency: string;
    isLootboxDetailPage: boolean;
    setLootboxDetailPage: (value: boolean)=>void;
    setCurrencyUSD: ()=>void;
    scrollToFilter: (forceScroll?: boolean, instantaneous?: boolean)=>void;
    shopStore?: ShopStore;
    location?: {
        pathname: string
    }
}

interface CasinoLootboxesState {
    isLootboxDetailPage: boolean;
}

class CasinoLootboxes extends Component<CasinoLootboxesInterface, CasinoLootboxesState> {
    state = {
        isLootboxDetailPage: this.props.isLootboxDetailPage || false
    };

    componentDidMount(): void {
        const {shopStore, location: {pathname}, setLootboxDetailPage} = this.props;
        const isLootboxDetailPath = pathname.includes('/lootboxes/');

        shopStore.setShopUrl('/shop/lootboxes');
        shopStore.updateShop(true);

        if (isLootboxDetailPath) {
            setLootboxDetailPage(true);
            this.setState({isLootboxDetailPage: true});
        }
    }

    componentDidUpdate(prevProps: CasinoLootboxesInterface): void {
        const {location: {pathname}, setLootboxDetailPage} = this.props;

        if (prevProps.location.pathname !== pathname) {
            const isLootboxPath = pathname.includes('lootboxes');
            setLootboxDetailPage(isLootboxPath);
            this.setState({isLootboxDetailPage: isLootboxPath});
        }
    }

    componentWillUnmount(): void {
        this.props.setLootboxDetailPage(false);
        this.setState({isLootboxDetailPage: false});
        this.props.setCurrencyUSD();
    }

    get filteredLootboxes(): Array<ShopItemInterface> {
        return this.props.shopStore.casinoLootboxes.filter(
            item => Number(item[isUSD(this.props.currency) ? 'cost_money' : 'cost_points']) > 0
        );
    }

    scrollToTopBlock = (): void => {
        if (isDesktop()) {
            setTimeout(() => this.props.scrollToFilter(true), 100);
            return;
        }

        this.props.scrollToFilter(true, true);
    };

    renderLootboxes = (lootboxes: Array<ShopItemInterface>): React.ReactNode => {
        if (lootboxes.length === 0) {
            return <EmptyShopResult currency={this.props.currency} />;
        }

        return <ShopItems
            currency={this.props.currency}
            user={this.props.shopStore.data.user}
            lootboxes={lootboxes}
            noChunks
            isCasinoPage
            scrollToTopBlock={this.scrollToTopBlock}
        />;
    };

    render(): React.ReactNode {
        const lootboxes = this.filteredLootboxes;

        return <div className="casino-lootboxes">
            {this.state.isLootboxDetailPage
                ? <Outlet />
                : this.renderLootboxes(lootboxes)
            }
        </div>;
    }
}

export default withRouter(inject('shopStore')(observer(CasinoLootboxes)));
